import React from 'react';
import { IconType } from 'react-icons';
import { FiCopy } from 'react-icons/fi';
import { useAuth } from '../../../../../hooks/Auth';
import { useLanguage } from '../../../../../hooks/Language';
import { useToast } from '../../../../../hooks/Toast';


// import { Container } from './styles';
interface IProps {
  text : string,
  Icon ?: IconType
}

const CopyToClipboard: React.FC<IProps> = ({ text, Icon = FiCopy }) => {

  const { user} = useAuth();
  const {translate} = useLanguage();
  const {addToast} = useToast();
  const copyToClipboard = (string) => {
    navigator.clipboard.writeText(string);
    addToast({type: 'success', 'title': translate('Copiado para o Clipboard')})

  }



  return (
    <div   style={{padding: '10px', cursor:'pointer', border: '2px solid #fff', borderRadius: '10px', width: '50px', height: '50px', display: 'flex', alignItems: 'center'}} title={translate("Clique para copiar")} onClick={() => copyToClipboard(text)}>
      <Icon size={30}/>
    </div>
  );
};

export default CopyToClipboard;
